// extracted by mini-css-extract-plugin
module.exports = {"UrgencyTimerWrapper":"UrgencyTimer_UrgencyTimerWrapper__dsoCs","UrgencyContent":"UrgencyTimer_UrgencyContent__FPMr1","TimerReadout":"UrgencyTimer_TimerReadout__Kd2J8"};